import { StrictMode, type ReactNode } from "react";
import { ThemeProvider } from "@jobenvoy/core";
import { ToastProvider } from "@jobenvoy/ui";

/**
 * The providers both sides render, so the server's tree and the browser's are one.
 * Only the query provider differs: the browser's keeps the catalogue across reloads.
 */
export default function AppProviders({
    queryProvider,
    children,
}: {
    queryProvider: (children: ReactNode) => ReactNode;
    children: ReactNode;
}) {
    return (
        <StrictMode>
            <ThemeProvider>
                {queryProvider(<ToastProvider>{children}</ToastProvider>)}
            </ThemeProvider>
        </StrictMode>
    );
}
